module.exports = __webpack_public_path__ + "static/media/scuba.d65bec34.jpg";